module.exports = __webpack_public_path__ + "img/image2.d1bc13ab.jpg";